import { lazy } from 'react';
const HolidayUpdate = lazy(() => import('./HolidayUpdate'));

const holidayUpdateRoutes = [
  {
    path: '/holiday-update',
    component: HolidayUpdate
  }
];
export default holidayUpdateRoutes;
